import { render, staticRenderFns } from "./TagSelection.vue?vue&type=template&id=276ec61a&scoped=true"
import script from "./TagSelection.vue?vue&type=script&lang=js"
export * from "./TagSelection.vue?vue&type=script&lang=js"
import style0 from "./TagSelection.vue?vue&type=style&index=0&id=276ec61a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276ec61a",
  null
  
)

export default component.exports